import { Component } from '@angular/core';
import { ElementBase } from "../element-base";

@Component({
  selector: 'app-element-checkbox',
  templateUrl: './element-checkbox.component.html',
  styleUrl: './element-checkbox.component.scss'
})
export class ElementCheckboxComponent extends ElementBase {



}
